module.exports = __webpack_public_path__ + "static/media/contract_card.2bf1c62b.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/contract_card.png
// module id = 509
// module chunks = 0